import $ from "jquery";
import {isMobile} from "Core/screenSizes";

export const notificationsPanelHeight = () => {
    const notificationsPanel = $('.header-notifications__items-wrapper');
    const headerHeight = $('.header__inner').height();
    const headerNotificationsHeaderHeight = $('.header-notifications__header').height();
    const headerNotificationsFooterHeight = $('.header-notifications__footer').height();

    if (isMobile()) {
        notificationsPanel.css({
            'height': $(window).height() - headerHeight - headerNotificationsHeaderHeight - headerNotificationsFooterHeight
        })
    }
};
